import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { showContactForm } from "../actions/index";
import Typography from '@material-ui/core/Typography';
import { CSSTransition } from 'react-transition-group';
import Button from '@material-ui/core/Button';

const duration = 3000;

const fullHeight = {
    height: '100%'
}

const center = {
    textAlign: 'center'
}

const textColorWhite = {
    color: '#ffffff'
}

const buttonStyle = {
    color: '#ffffff',
    borderColor: '#ffffff'
}

class FadeInText extends Component {
    constructor (props) {
        super(props);
        this.state = {
            show: false,
            entered: false,
        };

      this.handleShowContactForm = this.handleShowContactForm.bind(this);
    }

  handleShowContactForm() {
       this.props.dispatch(showContactForm({}));
  }

  componentDidMount() {
    this.setState({ show: true })
  }
  
  render() {
    const { show } = this.state;
    return (
    <div style={fullHeight}>
        <CSSTransition 
            in={show} 
            timeout={duration}
            classNames="title"
            unmountOnExit
            >
            <div className="container">
                <div id="title">
                    <Typography variant="display2" component="h1" style={textColorWhite}>
                        Richard Kwan
                    </Typography>
                    <div className="separator" />
                    <div style={center}>
                        <Button 
                        variant="outlined" 
                        style={buttonStyle}
                        onClick={this.handleShowContactForm}>Contact Me</Button>
                    </div>
                </div>
            </div>
        </CSSTransition>
    </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(showContactForm, dispatch) }
}

export default connect(mapDispatchToProps)(FadeInText);



// WEBPACK FOOTER //
// ./src/components/FadeInText.js